module.exports = __webpack_public_path__ + "img/BaaS.c8b47997.png";